// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

import AF from '../phoneNumberFormats/AF';
import AL from '../phoneNumberFormats/AL';
import DZ from '../phoneNumberFormats/DZ';
import AS from '../phoneNumberFormats/AS';
import AD from '../phoneNumberFormats/AD';
import AO from '../phoneNumberFormats/AO';
import AI from '../phoneNumberFormats/AI';
import AG from '../phoneNumberFormats/AG';
import AR from '../phoneNumberFormats/AR';
import AM from '../phoneNumberFormats/AM';
import AW from '../phoneNumberFormats/AW';
import AC from '../phoneNumberFormats/AC';
import AU from '../phoneNumberFormats/AU';
import AT from '../phoneNumberFormats/AT';
import AZ from '../phoneNumberFormats/AZ';
import BS from '../phoneNumberFormats/BS';
import BH from '../phoneNumberFormats/BH';
import BD from '../phoneNumberFormats/BD';
import BB from '../phoneNumberFormats/BB';
import BY from '../phoneNumberFormats/BY';
import BE from '../phoneNumberFormats/BE';
import BZ from '../phoneNumberFormats/BZ';
import BJ from '../phoneNumberFormats/BJ';
import BM from '../phoneNumberFormats/BM';
import BT from '../phoneNumberFormats/BT';
import BO from '../phoneNumberFormats/BO';
import BA from '../phoneNumberFormats/BA';
import BW from '../phoneNumberFormats/BW';
import BR from '../phoneNumberFormats/BR';
import IO from '../phoneNumberFormats/IO';
import VG from '../phoneNumberFormats/VG';
import BN from '../phoneNumberFormats/BN';
import BG from '../phoneNumberFormats/BG';
import BF from '../phoneNumberFormats/BF';
import BI from '../phoneNumberFormats/BI';
import KH from '../phoneNumberFormats/KH';
import CM from '../phoneNumberFormats/CM';
import CA from '../phoneNumberFormats/CA';
import CV from '../phoneNumberFormats/CV';
import BQ from '../phoneNumberFormats/BQ';
import KY from '../phoneNumberFormats/KY';
import CF from '../phoneNumberFormats/CF';
import TD from '../phoneNumberFormats/TD';
import CL from '../phoneNumberFormats/CL';
import CN from '../phoneNumberFormats/CN';
import CO from '../phoneNumberFormats/CO';
import KM from '../phoneNumberFormats/KM';
import CG from '../phoneNumberFormats/CG';
import CD from '../phoneNumberFormats/CD';
import CK from '../phoneNumberFormats/CK';
import CR from '../phoneNumberFormats/CR';
import HR from '../phoneNumberFormats/HR';
import CU from '../phoneNumberFormats/CU';
import CW from '../phoneNumberFormats/CW';
import CY from '../phoneNumberFormats/CY';
import CZ from '../phoneNumberFormats/CZ';
import CI from '../phoneNumberFormats/CI';
import DK from '../phoneNumberFormats/DK';
import DJ from '../phoneNumberFormats/DJ';
import DM from '../phoneNumberFormats/DM';
import DO from '../phoneNumberFormats/DO';
import EC from '../phoneNumberFormats/EC';
import EG from '../phoneNumberFormats/EG';
import SV from '../phoneNumberFormats/SV';
import GQ from '../phoneNumberFormats/GQ';
import ER from '../phoneNumberFormats/ER';
import EE from '../phoneNumberFormats/EE';
import SZ from '../phoneNumberFormats/SZ';
import ET from '../phoneNumberFormats/ET';
import FK from '../phoneNumberFormats/FK';
import FO from '../phoneNumberFormats/FO';
import FJ from '../phoneNumberFormats/FJ';
import FI from '../phoneNumberFormats/FI';
import FR from '../phoneNumberFormats/FR';
import GF from '../phoneNumberFormats/GF';
import PF from '../phoneNumberFormats/PF';
import GA from '../phoneNumberFormats/GA';
import GM from '../phoneNumberFormats/GM';
import GE from '../phoneNumberFormats/GE';
import DE from '../phoneNumberFormats/DE';
import GH from '../phoneNumberFormats/GH';
import GI from '../phoneNumberFormats/GI';
import GR from '../phoneNumberFormats/GR';
import GL from '../phoneNumberFormats/GL';
import GD from '../phoneNumberFormats/GD';
import GP from '../phoneNumberFormats/GP';
import GU from '../phoneNumberFormats/GU';
import GT from '../phoneNumberFormats/GT';
import GG from '../phoneNumberFormats/GG';
import GN from '../phoneNumberFormats/GN';
import GW from '../phoneNumberFormats/GW';
import GY from '../phoneNumberFormats/GY';
import HT from '../phoneNumberFormats/HT';
import HN from '../phoneNumberFormats/HN';
import HK from '../phoneNumberFormats/HK';
import HU from '../phoneNumberFormats/HU';
import IS from '../phoneNumberFormats/IS';
import IN from '../phoneNumberFormats/IN';
import ID from '../phoneNumberFormats/ID';
import IR from '../phoneNumberFormats/IR';
import IQ from '../phoneNumberFormats/IQ';
import IE from '../phoneNumberFormats/IE';
import IM from '../phoneNumberFormats/IM';
import IL from '../phoneNumberFormats/IL';
import IT from '../phoneNumberFormats/IT';
import JM from '../phoneNumberFormats/JM';
import JP from '../phoneNumberFormats/JP';
import JE from '../phoneNumberFormats/JE';
import JO from '../phoneNumberFormats/JO';
import KZ from '../phoneNumberFormats/KZ';
import KE from '../phoneNumberFormats/KE';
import KI from '../phoneNumberFormats/KI';
import XK from '../phoneNumberFormats/XK';
import KW from '../phoneNumberFormats/KW';
import KG from '../phoneNumberFormats/KG';
import LA from '../phoneNumberFormats/LA';
import LV from '../phoneNumberFormats/LV';
import LB from '../phoneNumberFormats/LB';
import LS from '../phoneNumberFormats/LS';
import LR from '../phoneNumberFormats/LR';
import LY from '../phoneNumberFormats/LY';
import LI from '../phoneNumberFormats/LI';
import LT from '../phoneNumberFormats/LT';
import LU from '../phoneNumberFormats/LU';
import MO from '../phoneNumberFormats/MO';
import MG from '../phoneNumberFormats/MG';
import MW from '../phoneNumberFormats/MW';
import MY from '../phoneNumberFormats/MY';
import MV from '../phoneNumberFormats/MV';
import ML from '../phoneNumberFormats/ML';
import MT from '../phoneNumberFormats/MT';
import MH from '../phoneNumberFormats/MH';
import MQ from '../phoneNumberFormats/MQ';
import MR from '../phoneNumberFormats/MR';
import MU from '../phoneNumberFormats/MU';
import YT from '../phoneNumberFormats/YT';
import MX from '../phoneNumberFormats/MX';
import FM from '../phoneNumberFormats/FM';
import MD from '../phoneNumberFormats/MD';
import MC from '../phoneNumberFormats/MC';
import MN from '../phoneNumberFormats/MN';
import ME from '../phoneNumberFormats/ME';
import MS from '../phoneNumberFormats/MS';
import MA from '../phoneNumberFormats/MA';
import MZ from '../phoneNumberFormats/MZ';
import MM from '../phoneNumberFormats/MM';
import NA from '../phoneNumberFormats/NA';
import NR from '../phoneNumberFormats/NR';
import NP from '../phoneNumberFormats/NP';
import NL from '../phoneNumberFormats/NL';
import NC from '../phoneNumberFormats/NC';
import NZ from '../phoneNumberFormats/NZ';
import NI from '../phoneNumberFormats/NI';
import NE from '../phoneNumberFormats/NE';
import NG from '../phoneNumberFormats/NG';
import NU from '../phoneNumberFormats/NU';
import NF from '../phoneNumberFormats/NF';
import KP from '../phoneNumberFormats/KP';
import MK from '../phoneNumberFormats/MK';
import MP from '../phoneNumberFormats/MP';
import NO from '../phoneNumberFormats/NO';
import OM from '../phoneNumberFormats/OM';
import PK from '../phoneNumberFormats/PK';
import PW from '../phoneNumberFormats/PW';
import PS from '../phoneNumberFormats/PS';
import PA from '../phoneNumberFormats/PA';
import PG from '../phoneNumberFormats/PG';
import PY from '../phoneNumberFormats/PY';
import PE from '../phoneNumberFormats/PE';
import PH from '../phoneNumberFormats/PH';
import PL from '../phoneNumberFormats/PL';
import PT from '../phoneNumberFormats/PT';
import PR from '../phoneNumberFormats/PR';
import QA from '../phoneNumberFormats/QA';
import RO from '../phoneNumberFormats/RO';
import RU from '../phoneNumberFormats/RU';
import RW from '../phoneNumberFormats/RW';
import RE from '../phoneNumberFormats/RE';
import WS from '../phoneNumberFormats/WS';
import SM from '../phoneNumberFormats/SM';
import SA from '../phoneNumberFormats/SA';
import SN from '../phoneNumberFormats/SN';
import RS from '../phoneNumberFormats/RS';
import SC from '../phoneNumberFormats/SC';
import SL from '../phoneNumberFormats/SL';
import SG from '../phoneNumberFormats/SG';
import SX from '../phoneNumberFormats/SX';
import SK from '../phoneNumberFormats/SK';
import SI from '../phoneNumberFormats/SI';
import SB from '../phoneNumberFormats/SB';
import SO from '../phoneNumberFormats/SO';
import ZA from '../phoneNumberFormats/ZA';
import KR from '../phoneNumberFormats/KR';
import SS from '../phoneNumberFormats/SS';
import ES from '../phoneNumberFormats/ES';
import LK from '../phoneNumberFormats/LK';
import SH from '../phoneNumberFormats/SH';
import KN from '../phoneNumberFormats/KN';
import LC from '../phoneNumberFormats/LC';
import PM from '../phoneNumberFormats/PM';
import VC from '../phoneNumberFormats/VC';
import SD from '../phoneNumberFormats/SD';
import SR from '../phoneNumberFormats/SR';
import SJ from '../phoneNumberFormats/SJ';
import SE from '../phoneNumberFormats/SE';
import CH from '../phoneNumberFormats/CH';
import SY from '../phoneNumberFormats/SY';
import ST from '../phoneNumberFormats/ST';
import TW from '../phoneNumberFormats/TW';
import TJ from '../phoneNumberFormats/TJ';
import TZ from '../phoneNumberFormats/TZ';
import TH from '../phoneNumberFormats/TH';
import TL from '../phoneNumberFormats/TL';
import TG from '../phoneNumberFormats/TG';
import TK from '../phoneNumberFormats/TK';
import TO from '../phoneNumberFormats/TO';
import TT from '../phoneNumberFormats/TT';
import TN from '../phoneNumberFormats/TN';
import TM from '../phoneNumberFormats/TM';
import TC from '../phoneNumberFormats/TC';
import TV from '../phoneNumberFormats/TV';
import TR from '../phoneNumberFormats/TR';
import VI from '../phoneNumberFormats/VI';
import UG from '../phoneNumberFormats/UG';
import UA from '../phoneNumberFormats/UA';
import AE from '../phoneNumberFormats/AE';
import GB from '../phoneNumberFormats/GB';
import US from '../phoneNumberFormats/US';
import UY from '../phoneNumberFormats/UY';
import UZ from '../phoneNumberFormats/UZ';
import VU from '../phoneNumberFormats/VU';
import VA from '../phoneNumberFormats/VA';
import VE from '../phoneNumberFormats/VE';
import VN from '../phoneNumberFormats/VN';
import WF from '../phoneNumberFormats/WF';
import EH from '../phoneNumberFormats/EH';
import YE from '../phoneNumberFormats/YE';
import ZM from '../phoneNumberFormats/ZM';
import ZW from '../phoneNumberFormats/ZW';
import AX from '../phoneNumberFormats/AX';

import createPhoneNumberUtils from '../createPhoneNumberUtils';

const phoneNumberUtils = createPhoneNumberUtils([
  AF,
  AL,
  DZ,
  AS,
  AD,
  AO,
  AI,
  AG,
  AR,
  AM,
  AW,
  AC,
  AU,
  AT,
  AZ,
  BS,
  BH,
  BD,
  BB,
  BY,
  BE,
  BZ,
  BJ,
  BM,
  BT,
  BO,
  BA,
  BW,
  BR,
  IO,
  VG,
  BN,
  BG,
  BF,
  BI,
  KH,
  CM,
  CA,
  CV,
  BQ,
  KY,
  CF,
  TD,
  CL,
  CN,
  CO,
  KM,
  CG,
  CD,
  CK,
  CR,
  HR,
  CU,
  CW,
  CY,
  CZ,
  CI,
  DK,
  DJ,
  DM,
  DO,
  EC,
  EG,
  SV,
  GQ,
  ER,
  EE,
  SZ,
  ET,
  FK,
  FO,
  FJ,
  FI,
  FR,
  GF,
  PF,
  GA,
  GM,
  GE,
  DE,
  GH,
  GI,
  GR,
  GL,
  GD,
  GP,
  GU,
  GT,
  GG,
  GN,
  GW,
  GY,
  HT,
  HN,
  HK,
  HU,
  IS,
  IN,
  ID,
  IR,
  IQ,
  IE,
  IM,
  IL,
  IT,
  JM,
  JP,
  JE,
  JO,
  KZ,
  KE,
  KI,
  XK,
  KW,
  KG,
  LA,
  LV,
  LB,
  LS,
  LR,
  LY,
  LI,
  LT,
  LU,
  MO,
  MG,
  MW,
  MY,
  MV,
  ML,
  MT,
  MH,
  MQ,
  MR,
  MU,
  YT,
  MX,
  FM,
  MD,
  MC,
  MN,
  ME,
  MS,
  MA,
  MZ,
  MM,
  NA,
  NR,
  NP,
  NL,
  NC,
  NZ,
  NI,
  NE,
  NG,
  NU,
  NF,
  KP,
  MK,
  MP,
  NO,
  OM,
  PK,
  PW,
  PS,
  PA,
  PG,
  PY,
  PE,
  PH,
  PL,
  PT,
  PR,
  QA,
  RO,
  RU,
  RW,
  RE,
  WS,
  SM,
  SA,
  SN,
  RS,
  SC,
  SL,
  SG,
  SX,
  SK,
  SI,
  SB,
  SO,
  ZA,
  KR,
  SS,
  ES,
  LK,
  SH,
  KN,
  LC,
  PM,
  VC,
  SD,
  SR,
  SJ,
  SE,
  CH,
  SY,
  ST,
  TW,
  TJ,
  TZ,
  TH,
  TL,
  TG,
  TK,
  TO,
  TT,
  TN,
  TM,
  TC,
  TV,
  TR,
  VI,
  UG,
  UA,
  AE,
  GB,
  US,
  UY,
  UZ,
  VU,
  VA,
  VE,
  VN,
  WF,
  EH,
  YE,
  ZM,
  ZW,
  AX,
]);

export default phoneNumberUtils;
